export default "/images/26d16e8640d8c03c45b86fc964b3b7ae.avif";